import React, {useContext, useEffect, useState} from 'react';
import './style.scss'
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import axios from "axios";
import {AppContext} from "../../../../../../Utils/AppContext";
import moment from 'moment';
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button";
import CreditDialog from "./CreditDialog/CreditDialog";
import {splitToChunks} from "../../../../../../../Utils/ArrayUtils";
import * as permissionTypes from "../../../../../../../Utils/Permissions/PermissionTypes";
import {getComparator, stableSort} from "../../../../../../Utils/TableUtils/Functions";
import {EnhancedTableHead} from "../../../../../../Utils/TableUtils/EnhancedTableHead";


const headCells = [
    {id: 'label', label: '#'},
    {id: 'address', label: 'כתובת'},
    {id: 'orderTime', label: 'זמן הזמנה'},
    {id: 'totalOwe', label: 'סה״כ מזומן'},
    {id: 'remainingOwe', label: 'חייב'}
];

export default function MessengerOrdersOwesSummary(props) {
    const appContext = useContext(AppContext);
    const [isLoading, setLoading] = useState(undefined);
    const [isOrdersVisible, setOrdersVisible] = useState(false);
    const [isCreditDialogOpen, setCreditDialogOpen] = useState(false);
    const [orders, setOrders] = useState(undefined);
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('orderTime');
    const [sumRemainingOwe, setSumRemainingOwe] = React.useState(0);


    async function queryOrders() {
        setLoading(true);

        const {data: messengerOrdersOwes} = await axios.get('api/v2/messengers/owes', {
            params: {
                bid: appContext.bid,
                messengerId: props.messenger.id,
                remainingOweGt: 0,
                oweTypes: ["ORDER"]
            }
        });

        if (messengerOrdersOwes.length > 0) {
            const chunksOrderIds = splitToChunks(messengerOrdersOwes.map(owe => owe.orderId), 100);

            const newOrders = [];

            for (let chunkedOrderIds of chunksOrderIds) {
                const {data: chunkOrders} = await axios.get('api/v2a/getOrders', {
                    params: {
                        bid: appContext.bid,
                        messengerId: props.messenger.id,
                        orderIds: chunkedOrderIds,
                        includeArchived: "true"
                    }
                });

                newOrders.push(...chunkOrders)
            }

            const ordersOwesIndex = messengerOrdersOwes.reduce(function (result, item) {
                result[item.orderId] = item;
                return result;
            }, {});

            let newSumRemainingOwe = 0;

            for (let currOrder of newOrders) {
                newSumRemainingOwe += ordersOwesIndex[currOrder.id].remainingOwe;

                currOrder.oweId = ordersOwesIndex[currOrder.id].id;
                currOrder.remainingOwe = ordersOwesIndex[currOrder.id].remainingOwe;
                currOrder.totalOwe = ordersOwesIndex[currOrder.id].totalOwe;
            }

            setSumRemainingOwe(newSumRemainingOwe);

            setOrders(newOrders);
        } else {
            setSumRemainingOwe(0);

            setOrders([]);
        }

        setLoading(false);
    }

    function onRequestSort(event, property) {
        setOrder(orderBy === property && order === 'desc' ? 'asc' : 'desc');
        setOrderBy(property);
    }

    function onCreditClicked() {
        setCreditDialogOpen(true);
    }

    function closeCreditDialog() {
        setCreditDialogOpen(false);
    }

    async function onCreditRequest(amount) {
        if (amount <= 0)
            return;

        const sortedOrders = stableSort(orders, getComparator("asc", "orderTime"));

        let remainingAmount = amount;

        for (let order of sortedOrders) {
            const currOrderCredit = remainingAmount > order.remainingOwe ? order.remainingOwe : remainingAmount;

            await axios.post('/api/v2/messengers/owes/transactions', {
                bid: appContext.bid,
                oweId: order.oweId,
                amount: currOrderCredit
            });

            remainingAmount -= currOrderCredit;
        }

        queryOrders();

        setCreditDialogOpen(false);

        if (props.onCredit)
            props.onCredit(amount);
    }

    useEffect(() => {
        if (props.messenger)
            queryOrders();
        else
            setOrders();
    }, [props.messenger]);

    if (isLoading === undefined)
        return null;

    if (isLoading) {
        return (
            <div className="messenger-orders-owes-summary">
                <div className="loader-container">
                    <CircularProgress size={80} thickness={2}/>
                </div>
            </div>
        );
    }

    return (
        <div className="messenger-orders-owes-summary">
            {
                sumRemainingOwe === 0 ?
                    <div className="owe-summary">
                        <div className="owe-summary-text">
                            השליח לא חייב מזומן
                        </div>
                    </div>
                    :
                    <div className="owe-summary">
                        <div className="owe-summary-text">
                            השליח חייב במזומן <span
                            className="owe-summary-remaining-money-text">₪{sumRemainingOwe}</span>
                        </div>
                        {
                            appContext.permissions.isPermitted(permissionTypes.ADD_MESSENGER_ORDER_OWE_TRANSACTION) ?
                                <React.Fragment>
                                    <Button className="credit-button" size="medium" color="primary"
                                            onClick={onCreditClicked}
                                            variant="contained">
                                        זכה
                                    </Button>
                                    <CreditDialog isOpen={isCreditDialogOpen}
                                                  onCloseRequest={closeCreditDialog}
                                                  onCreditRequest={onCreditRequest}
                                                  maxCreditAmount={sumRemainingOwe}/>
                                </React.Fragment>
                                :
                                null
                        }
                    </div>
            }
            {orders && orders.length > 0 ?
                <React.Fragment>
                    <div onClick={() => setOrdersVisible(!isOrdersVisible)}
                         className={"show-hide-owed-orders-table-title " + (isOrdersVisible ? "hide-owed-orders-table-title" : "show-owed-orders-table-title")}>
                        <div className="show-hide-owed-orders-table-title-text">
                            {
                                isOrdersVisible ?
                                    <React.Fragment>
                                        הסתר פרטי הזמנות
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        הצג פרטי הזמנות
                                    </React.Fragment>
                            }
                        </div>
                        <div className="expand-icon">
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    <Collapse in={isOrdersVisible}>
                        <TableContainer className="owed-orders-table" component={Paper}>
                            <Table stickyHeader aria-label="simple table">
                                <EnhancedTableHead
                                    headCells={headCells}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={onRequestSort}
                                />
                                <TableBody>
                                    {stableSort(orders,
                                        getComparator({
                                            "asc": "desc",
                                            "desc": "asc"
                                        }[order], orderBy)).map((order) => (
                                        <TableRow key={order.id}>
                                            <TableCell>{order.label}</TableCell>
                                            <TableCell>{order.address}</TableCell>
                                            <TableCell>{moment(order.orderTime).format('DD/MM/YYYY, HH:mm')}</TableCell>
                                            <TableCell>₪{order.totalOwe}</TableCell>
                                            <TableCell>₪{order.remainingOwe}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Collapse>
                </React.Fragment>
                :
                null
            }
        </div>
    );
}